"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _Review = _interopRequireDefault(require("ecosystem-marketplace-core/records/Review"));

var _auth = require("../../../selectors/auth");

var _reviews = require("../../../selectors/reviews");

var _ReviewsActions = require("../../../actions/ReviewsActions");

var textPath = 'appMarketplace.detail.reviews';

var HelpfulButton = function HelpfulButton(_ref) {
  var className = _ref.className,
      isCustomer = _ref.isCustomer,
      review = _ref.review;
  var userId = (0, _reactRedux.useSelector)(_auth.getUserId);
  var getUserMarkedHelpful = (0, _react.useMemo)(_reviews.makeGetUserMarkedHelpfulSelector, []);
  var userMarkedHelpful = (0, _reactRedux.useSelector)(function (state) {
    return getUserMarkedHelpful(state, review.get('id'));
  });
  var dispatch = (0, _reactRedux.useDispatch)();
  return _react.default.createElement(_UITooltip.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "appMarketplace.loginRequired"
    }),
    disabled: isCustomer
  }, _react.default.createElement(_UIButton.default, {
    className: className,
    style: {
      fontWeight: userMarkedHelpful ? 1000 : 600
    },
    disabled: !isCustomer,
    use: "link",
    onClick: function onClick() {
      return dispatch((0, _ReviewsActions.setReviewHelpful)(review.get('id'), userId, !userMarkedHelpful));
    }
  }, _react.default.createElement(_UIIcon.default, {
    name: "thumbsUp",
    size: "small",
    color: userMarkedHelpful ? _colors.CALYPSO_DARK : _colors.GREAT_WHITE,
    className: "m-right-1"
  }), _react.default.createElement(_FormattedMessage.default, {
    message: textPath + ".helpful.text",
    options: {
      count: review.getHelpfulCount()
    }
  })));
};

HelpfulButton.propTypes = {
  className: _propTypes.default.string,
  isCustomer: _propTypes.default.bool.isRequired,
  review: _propTypes.default.instanceOf(_Review.default).isRequired
};
var _default = HelpfulButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/reviews/HelpfulButton.js
// module id = 424
// module chunks = 209 210 211 212